import http from "@/libs/http";
const user = {
  /**获取当前用户信息 */
  userCurrent: () => {
    return http.get(http.formatUrl("user/current"));
  },
  /**修改默认密码 */
  defaultPasswordUpdate: UpdateDefaultPasswordVO => {
    return http.post(http.formatUrl("user/default/password/update"), UpdateDefaultPasswordVO);
  },
  /**修改密码 */
  passwordUpdate: UpdatePasswordVO => {
    return http.post(http.formatUrl("user/password/update"), UpdatePasswordVO);
  },
  /**重置用户密码 */
  passwordReset: UserResetPasswordVO => {
    return http.post(http.formatUrl("user/password/reset"), UserResetPasswordVO);
  }
};
export default user;
